import { Component, HostBinding, Input } from '@angular/core';
import { PcpIconComponent } from '../common/pcp-ui-icon.component';

@Component({
    selector: 'pcp-ui-driverscam-icon',
    templateUrl: './driverscam-icon.component.html',
    styleUrls: ['./driverscam-icon.component.scss']
})
export class DriverscamIconComponent extends PcpIconComponent {
}
